// @ts-nocheck: CSS side-effect imports have no type declarations
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/app.css";
import { Root } from "./Root";

// Bump the asset fingerprint after a stale Pages fallback was cached as JavaScript.
document.documentElement.dataset.build = "2026-08-21.1";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
